import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import { SurveyStatusService } from "../survey-status.service";
import * as catColumnas from "./catalogoColumnas";
import Swal from 'sweetalert2';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-nuevo-colaborador',
  templateUrl: './nuevo-colaborador.component.html',
  styleUrls: ['./nuevo-colaborador.component.scss']
})
export class NuevoColaboradorComponent implements OnInit {

  instituto_id: string;
  catalogos: any;
  columnas:any[] = catColumnas.CLAVES_COLUMNAS;
  datosColaborador: any = {};
  datasets: FormGroup[] = [];
  formValido: boolean;

  surveyKeyRandom: string;

  charChinos = '\u2E80-\u2FD5\u3400-\u4DBF\u4E00-\u9FCC';
  charTurcos = '\u011F\u011E\u0131\u0130\u00F6\u00D6\u00FC\u00DC\u015F\u015E\u00E7\u00C7';

  charIdiomas = this.charChinos + this.charTurcos;

  regexAlfabetico = new RegExp("^[" + this.charIdiomas + "a-zA-Z  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexAlfanumerico = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9  ÀÈÌÒÙàèìòùÁÉÍÓÚÜáéíóúüñÑ()@/–&.,:!*\"#$%=´`'|;_<>}{[+-\\]]*$");
  regexNumerico = new RegExp("^[0-9]+$");
  regexEmail = new RegExp("^[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[" + this.charIdiomas + "a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?\.)+[" + this.charIdiomas + "a-zA-Z0-9](?:[" + this.charIdiomas + "a-zA-Z0-9-]*[" + this.charIdiomas + "a-zA-Z0-9])?$");

  catGeneracion = 0;
  catGeneracionUS = 0;
  catEdadUS = 0;
  catAntiquity = 0;
  catAntiquityUS = 0;

  filtroCalendario = (d: Date | null): boolean => {
    let diaInicial = this.moment();
    const diaActual = this.moment(d || new Date()); //dia "actual" significa el dia que se evalúa (se recorre todo el mes) en comparacion con la fecha de hoy
    return diaActual.isBefore(diaInicial)
  };

  //libreria moment
  moment = require('moment');
  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<NuevoColaboradorComponent>,
    private surveyServ: SurveyStatusService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService
  ) {
    console.log("datosrecibidos:",this.datos);

    // this.instituto_id = localStorage.getItem('instituto_empresa');
    localStorage.getItem('instituto_empresa') ? this.instituto_id = localStorage.getItem('instituto_empresa') : this.instituto_id = localStorage.getItem('institutoValidacionEtiquetas');

    console.log("Instituto "+this.instituto_id);
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.filtrarColumnas();
    this.obtenerCatalogos();
    // this.buscarSurveyKey(1111);
    // this.buscarSurveyKey(548438);
  }

  filtrarColumnas(){
    //let instituto = localStorage.getItem('instituto_id');
    // let instituto = localStorage.getItem('instituto_empresa');
    let catalogoBuscar: any;
    this.columnas = catColumnas.CLAVES_COLUMNAS;
    // console.log("institutobuiscar:",instituto);

    switch (this.instituto_id) {
      case "1": catalogoBuscar = catColumnas.COLUMNAS_MX; break;
      case "2": catalogoBuscar = catColumnas.COLUMNAS_CAYC; break;
      case "3": catalogoBuscar = catColumnas.COLUMNAS_HK; break;
      case "5": catalogoBuscar = catColumnas.COLUMNAS_TR; break;
      default: catalogoBuscar = catColumnas.COLUMNAS_WWDE;
    }
    this.columnas.forEach(columna => {
      let indiceCatalogo = catalogoBuscar.findIndex(item => item.clave == columna.clave);
      if(indiceCatalogo != -1){
        columna.visible = true;
        columna.obligatorio = catalogoBuscar[indiceCatalogo].obligatorio;
        this.datosColaborador[columna.clave] = null;
      }
    });
    console.log("columnasTrasFiltro:",this.columnas);
    console.log("objetoDatos:",this.datosColaborador);

    this.creaFormGroups();
  }

  obtenerCatalogos(){
    //let instituto = localStorage.getItem('instituto_id');
    // let instituto =localStorage.getItem('instituto_empresa');
    this.surveyServ.getCatalogos(this.instituto_id,this.translateSrv.currentLang).subscribe((respuesta:any) => {
      console.log("catalogos:",respuesta);
      this.catalogos = respuesta.jsonConfig;
    }, error  => {
      console.log("error");
    });
  }

  creaFormGroups(){
    let dataSetActual = 0;
    let group = {};
    this.columnas.forEach(columna => {
      if(columna.visible){
        if(dataSetActual != columna.dataset){
          if(dataSetActual > 0){
            if(dataSetActual == 1){ //si acaba de pasar al segundo formulario y es instituto tr o hk, agrega el formcontrol surveykey al primer formulario
              if(this.instituto_id == "3" || this.instituto_id == "5"){
                group['surveyKey'] = new FormControl('');
              }
            }
            this.datasets.push(new FormGroup(group) );
          }
          dataSetActual = columna.dataset;
          group = {};
        }
        switch (columna.clave) {
          case 'bossName': case 'antiquity': case 'antiquityUS': case 'generation': case 'generationUS': case 'ageUS':
            group[columna.clave] = new FormControl({ value: '', disabled: true });
          break;
          case 'surveyKey':
            if(this.datos.modificacion){
              group[columna.clave] = new FormControl({ value: '', disabled: true });
            }
            else{
              group[columna.clave] = new FormControl('');
            }
          break;
          case 'ownKey':
            if(this.datos.modificacion){
              group[columna.clave] = new FormControl({ value: '', disabled: true });
            }
            else{
              group[columna.clave] = new FormControl('');
            }
          break;
          default:
            group[columna.clave] = new FormControl('');
        }
      }
    });
    //inserta el ultimo formgroup
    this.datasets.push(new FormGroup(group) );
    console.log("formgroups:",this.datasets);

    if(this.instituto_id == "3" || this.instituto_id == "5"){
      this.clavesRandom();  //se genera una surveykey random
    }

    if(this.datos.datosColaborador){
      this.llenaInfoColaborador();
    }

    this.datasets.forEach((dataset,i) => {
      dataset.valueChanges.subscribe( (res) => {
        // console.log("dataset",i,":",dataset.status);

        if(dataset.status == 'VALID'){
          this.formValido = this.formValido && true;
        }
        else{
          this.formValido = this.formValido && false;
        }
      });
    });
  }

  llenaInfoColaborador(){
    this.datasets.forEach((dataset,i) => {
      for(let k in this.datos.datosColaborador){
        if(dataset.controls.hasOwnProperty(k)){
          if(k == 'enterDate'){
            if(this.datos.datosColaborador[k] != "Invalid date" && this.datos.datosColaborador[k] != ""){
              let fechaVal = new Date(new Date(this.datos.datosColaborador[k]).getTime());
              dataset.controls[k].setValue(fechaVal);
            }
          }
          else{
            dataset.controls[k].setValue(this.datos.datosColaborador[k]);
          }
        }
      }
    });
  }

  buscaOwnkey(ownKey:any){
    // console.log(ownKey.target.value);
    if(ownKey.target.value != ""){
      let datos: any = {ownKey:ownKey.target.value};
      this.surveyServ.buscaOwnkey(this.datos.idProducto,datos).subscribe((respuesta:any) => {
        console.log("respuestaownkey:",respuesta);
        if(!respuesta.success){
          this.datasets[0].controls['ownKey'].setValue('');
          this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_OWNKEY'),2);
        }
      });
    }
  }
  buscaBossKey(bossKey:any){
    // console.log(bossKey.target.value);
    if(bossKey.target.value != ""){
      let datos: any = {bossKey:bossKey.target.value};
      this.surveyServ.buscaBossKey(this.datos.idProducto,datos).subscribe((respuesta:any) => {
        console.log("respuestabossKey:",respuesta);
        if(respuesta.success){
          this.datasets[0].controls['bossName'].setValue(respuesta.bossKey);
        }
        else{
          this.datasets[0].controls['bossName'].setValue('');
          this.datasets[0].controls['bossKey'].setValue('');
          this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_BOSSKEY'),2);

        }
      });
    }
  }
  buscarSurveyKey(surveyKey:any){
    // console.log(surveyKey.target.value);
    // let datos: any = {surveyKey:surveyKey.target.value};
    let datos: any = {surveyKey};
    this.surveyServ.buscarSurveyKey(this.datos.idProducto,datos).subscribe((respuesta:any) => {
      console.log("respuestasurveyKey:",respuesta);
      if(respuesta.success){
        this.surveyKeyRandom = surveyKey;
        this.datasets[0].controls['surveyKey'].setValue(surveyKey);
      }
      else this.clavesRandom();
    });
  }
  buscarEmail(email:any){
    if(email.target.value != ""){
      if(email.target.value != "*"){
        let paramExtra: string;
        switch (this.datos.nombreProductoSel) {
          case "Focus Area": paramExtra = "null"; break;
          default: paramExtra = "null"; break;
        }
        this.surveyServ.buscarEmail(this.datos.idProducto, email.target.value, paramExtra).subscribe((respuesta:any) => {
          console.log("respuestabuscarEmail:",respuesta);
          if(respuesta.success){
            this.datasets[0].controls['email'].setValue('');
            this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_EMAIL'),2);
          }
        });
      }
    }
  }

  validarDato(dato:any,tipoValidacion:string,numCampo:number){
    let datoCorrecto = true;
    switch (tipoValidacion) {
      case "alfabetica":
        datoCorrecto = this.regexAlfabetico.test(dato.target.value);
      break;
      case "alfanumerica":
        datoCorrecto = this.regexAlfanumerico.test(dato.target.value);
      break;
      case "email":
        if(dato.target.value == "*"){
          datoCorrecto = true;
        }
        else{
          datoCorrecto = this.regexEmail.test(dato.target.value);
        }
      break;
      case "numerica":
        datoCorrecto = this.regexNumerico.test(dato.target.value);
      break;
    }
    // console.log("dato:",dato.target.value," tipoVal:",tipoValidacion," resultado:",datoCorrecto);

    if(!datoCorrecto){
      this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_VAL_1') + this.columnas[numCampo].clave + this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_VAL_2'), 2);
      this.datasets[this.columnas[numCampo].dataset - 1].controls[this.columnas[numCampo].clave].setValue('');
    }
    else{
      switch (this.columnas[numCampo].clave) {
        case 'ownKey': case 'age':
          // if(this.instituto_id != "3" && this.instituto_id != "5"){
          //   let surveyKey = this.datasets[0].controls['ownKey'].value.toString() + this.datasets[0].controls['age'].value.toString();
          //   this.datasets[this.columnas[numCampo].dataset - 1].controls['surveyKey'].setValue(surveyKey);
          // }
          let anio = parseInt(this.datasets[0].controls['age'].value);
          console.log("edad:",anio);

          if(this.instituto_id == "1"){
            var BreakException = {};
            let genUsFnd:boolean;
            try {
              catColumnas.CAT_GENERACION_US.forEach((anioGen,i) => {
                if(anioGen > anio){
                  this.catGeneracionUS = i;
                  genUsFnd = true;
                  throw BreakException;
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            };
            if(!genUsFnd){
              this.catGeneracionUS = catColumnas.CAT_GENERACION_US.length - 1;
            }

            let edad = this.moment().year() - anio;
            var BreakException2 = {};
            let ageUsFnd:boolean;
            try {
              catColumnas.CAT_EDAD_US.forEach((anioEdad,i) => {
                if(anioEdad > edad){
                  this.catEdadUS = i;
                  ageUsFnd = true;
                  throw BreakException2;
                }
              });
            } catch (e) {
              if (e !== BreakException2) throw e;
            };
            if(!ageUsFnd){
              this.catEdadUS = catColumnas.CAT_EDAD_US.length - 1;
            }
            console.log("genUS:",this.catGeneracionUS," eddUS:",this.catEdadUS);
            this.datasets[3].controls['generationUS'].setValue(this.catalogos.generationUS[this.catGeneracionUS].nombre);
            this.datasets[3].controls['ageUS'].setValue(this.catalogos.ageUS[this.catEdadUS].nombre);
          }
          var BreakException = {};
          let generFnd:boolean;
          try {
            catColumnas.CAT_GENERACION.forEach((anioGen,i) => {
              if(anioGen > anio){
                this.catGeneracion = i;
                generFnd = true;
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };
          if(!generFnd){
            this.catGeneracion = catColumnas.CAT_GENERACION.length - 1;
          }
          console.log("generacion:",this.catGeneracion);
          this.datasets[3].controls['generation'].setValue(this.catalogos.generation[this.catGeneracion].nombre);

          //comprueba iguales
          let bossKey_1 = this.datasets[this.columnas[numCampo].dataset - 1].controls['bossKey'].value.toString();
          let ownKey_1 = this.datasets[this.columnas[numCampo].dataset - 1].controls['ownKey'].value.toString();
          if(bossKey_1 != ""){
            if(ownKey_1 == bossKey_1){
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_SAMEKEY'), 2);
              this.datasets[this.columnas[numCampo].dataset - 1].controls['ownKey'].setValue('');
            }
          }

        break;
        case 'bossKey':
          let bossKey = this.datasets[this.columnas[numCampo].dataset - 1].controls['bossKey'].value.toString();
          let ownKey = this.datasets[this.columnas[numCampo].dataset - 1].controls['ownKey'].value.toString();
          if(ownKey != ""){
            if(bossKey == ownKey){
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.ERR_SAMEKEY'), 2);
              this.datasets[this.columnas[numCampo].dataset - 1].controls['bossKey'].setValue('');
            }
          }
        break;
        case 'enterDate':
          let enterdate = this.datasets[this.columnas[numCampo].dataset - 1].controls['enterDate'].value.toString();
          let entrada= this.moment(enterdate);
          let hoy= this.moment();
          let mesesDiferencia=hoy.diff(entrada,'months');
          console.log("mesDiff:",mesesDiferencia);

          if(this.instituto_id == "1"){
            var BreakException = {};
            let antiqUS:boolean;
            try {
              catColumnas.CAT_ANTIGUEDAD_US.forEach((mesesMax,i) => {
                if(mesesMax > mesesDiferencia){
                  this.catAntiquityUS = i;
                  antiqUS = true;
                  throw BreakException;
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            };
            if(!antiqUS){
              this.catAntiquityUS = catColumnas.CAT_ANTIGUEDAD_US.length - 1;
            }
            console.log("antiqUS:",this.catAntiquityUS);
            this.datasets[3].controls['antiquityUS'].setValue(this.catalogos.antiquityUS[this.catAntiquityUS].nombre);
          }
          var BreakException = {};
          let antiq:boolean;
          try {
            catColumnas.CAT_ANTIGUEDAD.forEach((mesesMax,i) => {
              if(mesesMax > mesesDiferencia){
                this.catAntiquity = i;
                antiq = true;
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          };
          if(!antiq){
            this.catAntiquity = catColumnas.CAT_ANTIGUEDAD.length - 1;
          }
          console.log("antiq:",this.catAntiquity);
          this.datasets[3].controls['antiquity'].setValue(this.catalogos.antiquity[this.catAntiquity].nombre);
          // this.datasets[this.columnas[numCampo].dataset - 1].controls['surveyKey'].setValue(surveyKey);

        break;
      }
    }
  }

  clavesRandom(){
    let clave: any;
    clave = Math.floor(Math.random() * (999999 - 100000 + 1) ) + 100000;
    this.buscarSurveyKey(clave.toString());
  }

  setVarsExtra(datosFormulario: any){
    let claveIdioma = datosFormulario.native.substr(0,2);
    switch (claveIdioma) {
      case "z1": claveIdioma = "zh1"; break;
      case "z2": claveIdioma = "zh2"; break;
    }
    let claveAnswer = parseInt(datosFormulario.answer.substr(0,2));
    // if(claveAnswer < 10){
    //   claveAnswer = 1;
    // }
    datosFormulario.lang = claveIdioma;
    datosFormulario.sendingType = claveAnswer;
    return datosFormulario;
  }

  guardaColaborador(){
    // console.log("datos del colaborador:",this.datosColaborador);
    //this.translateSrv.instant('CONSULTATABLA.EDITORMAILODS.MODAL_OP1_ON')
    let formValido: boolean = true;
    let datosFormulario: any = {};
    var BreakException = {};
    try {
      this.datasets.forEach((dataset,i) => {
        // console.log("dataset:",dataset);
        // datosFormulario = {...dataset.value};
        // datosFormulario = Object.assign(dataset.value);
        _.merge(datosFormulario,dataset.getRawValue());
        if(dataset.status != 'VALID'){
          formValido = false;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    let fechaOriginal = datosFormulario.enterDate;
    if(fechaOriginal != ""){
      datosFormulario.enterDate = this.moment(fechaOriginal).format('MM/DD/YYYY');
    }
    console.log("datosFormulario:",datosFormulario);

    if(formValido){
      switch (this.datos.nombreProductoSel) {
        case "Certificar": datosFormulario.claveProd = 1; break;
        case "PulseCheck": datosFormulario.claveProd = 4; break;
        case "Nom035": datosFormulario.claveProd = 3; break;
        case "Focus Area": datosFormulario.claveProd = 6; break;
        default:
          if(this.datos.nombreProductoSel.includes('Medir')){
            datosFormulario.claveProd = 2;
          }
      }
      let datosFormularioPrevioMod = JSON.parse(JSON.stringify(datosFormulario));
      datosFormulario = this.setVarsExtra(datosFormulario);
      Swal.fire({
        title: this.translateSrv.instant('AVANCES.NEWCOLAB.GUARDANDO'),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      });
      if(this.datos.datosColaborador){
        if(this.datos.prodFocus){   //si se accede desde el administrador de focus
          this.surveyServ.updateColaboradorFocus(this.datos.datosColaborador._id,datosFormulario).subscribe((respuesta:any) => {
            console.log("updateColaborador:",respuesta);
            if(respuesta.success){
              datosFormularioPrevioMod._id = this.datos.datosColaborador._id;
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.MOD_OK'),1,true,datosFormularioPrevioMod);
            }
          });
        } else{
          this.surveyServ.updateColaborador(this.datos.datosColaborador._id,this.datos.SurveyId,datosFormulario).subscribe((respuesta:any) => {
            console.log("updateColaborador:",respuesta);
            if(respuesta.success){
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.MOD_OK'),1,true);
            }
          });
        }
      }
      else{
        if(this.datos.prodFocus){   //si se accede desde el administrador de focus
          datosFormulario.empresaId = this.datos.idEmpresa;
          datosFormulario.productoId = '';
          this.surveyServ.saveColaboradorNuevoFocus(this.datos.idEmpresa,datosFormulario).subscribe((respuesta:any) => {
            console.log("saveColab:",respuesta);
            if(respuesta.success){
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.SAVE_OK'),1,true,datosFormularioPrevioMod);
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('AVANCES.ENCUESTA.ERROR1'),3);
            }
          });
        } else{
          this.surveyServ.saveColaboradorNuevo(this.datos.idEmpresa,this.datos.idProducto,datosFormulario).subscribe((respuesta:any) => {
            console.log("saveColab:",respuesta);
            if(respuesta.success){
              this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.SAVE_OK'),1,true);
            }
            else{
              this.mensajeSwal(this.translateSrv.instant('AVANCES.ENCUESTA.ERROR1'),3);
            }
          });
        }
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('AVANCES.NEWCOLAB.FORMULARIO'),2);
    }
  }

  mensajeSwal(mensaje:string, tipoMsg:number, cerrarModal?:boolean, datosObtenidos?:any){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    }).then((result) => {
      if (result.value) {
        if(cerrarModal){
          if(datosObtenidos){
            this.salir(cerrarModal, datosObtenidos);
          } else{
            this.salir(cerrarModal);
          }
        }
      }
    });
  }

  salir(respuesta?:any, datosObtenidos?:any) {
    if(datosObtenidos){
      this.dialogRef.close({respuesta, datosObtenidos});
    } else{
      this.dialogRef.close(respuesta);
    }
  }


}
